//import {Client} from "@googlemaps/google-maps-services-js";
import { Loader } from "@googlemaps/js-api-loader"

var autocomplete = null;
var geolocation;
function updateRegions(countryId, form) {
	var dfd = new $.Deferred();
	// var countryId = countriesIndex[country];
	if (!countryId) {
		dfd.resolve([]);
		return;
	}

	if (!countryId) {
		form.find(".region")
			.empty()
			.prop('disabled', true)
			.prepend(
				$('<option>').attr('value', '').html('(Select a country first)')
			);
		return null;
	}
	$.ajax({
		data: {
			action: 'getRegions',
			countryId: countryId
		},
		success: function (data) {
			var list = $.parseJSON(data);
			displayRegions(form, list);
			dfd.resolve(list);
		},
		error: function () {
			dfd.reject();
		}
	});
	return dfd.promise();
}

function displayRegions(form, list) {
	let hasRegions = false;

	form.find(".region").empty();
	$.each(list, function (index, region) {
		hasRegions = true;
		form.find(".region").append(
			$('<option>').attr('value', region.id).text(region.name)
		);
	});
	if (hasRegions) {
		form.find(".region").prop('disabled', false).prepend(
			$('<option>').attr('value', '').html('Please select&hellip;')
		);
		form.find(".region").val('');
	} else {
		form.find(".region").prop('disabled', true).prepend(
			$('<option>').attr('value', '').html('N/A')
		);
	}
}

function initializeAutoComplete() {
	//var field = $("#acct_billing_streetAddress")

	const loader = new Loader({
	  apiKey: HF_GLOBALS.googleApiKey,
	  version: "weekly"
	});

	loader.load().then(async () => {

		const { Autocomplete } = await google.maps.importLibrary("places");

		$('.addressForm .autocomplete').each(function () {
			var field = $(this);
			var autocomplete = new Autocomplete(
				this, {
					types: ['geocode']
				});

			$(this).one('focus', geolocate);
			// Avoid paying for data that you don't need by restricting the set of
			// place fields that are returned to just the address components.
			autocomplete.setFields(['address_component']);

			// When the user selects an address from the drop-down, populate the
			// address fields in the form.
			autocomplete.addListener('place_changed', function () {
				fillInAddress(autocomplete, field.closest('.addressForm'));
			});
			field.data('autocomplete', autocomplete);
		});
	});

}

function fillInAddress(autocomplete, form) {
	var place = autocomplete.getPlace();
	//console.log(place)
	if (!place) {
		return;
	}

	var addressObj = {
		'postal_code': '',
		'route': '',
		'street_number': '',
		'city': '',
		'region': '',
		'country': ''
	};

	// Get each component of the address from the place details,
	// and then fill-in the corresponding field on the form.
	for (var i = 0; i < place.address_components.length; i++) {
		var addressType = place.address_components[i].types[0];
		var value = place.address_components[i].long_name;
		switch (addressType) {
		case "postal_code":

			addressObj.zipcode = value;
			break;
		case "postal_code_prefix":
			addressObj.zipcode = addressObj.zipcode || value;
			break;
		case "country":
			addressObj.country = value;
			break;
		case "administrative_area_level_1":
			addressObj.region = addressObj.region || value;
			break;
		case "street_number":
			addressObj.street_number = value;
			break;
		case "route":
			addressObj.route = value;
			break;
		case "locality":
			addressObj.city = addressObj.city || value;
			break;
		case "postal_town":
			addressObj.city = addressObj.city || value;
			break;
		case "administrative_area_level_3":
			addressObj.city = addressObj.city || value;
			break;
		case "sublocality_level_1":
			addressObj.city = addressObj.city || value;
			break;
		}
	}
	//addressObj = place.formatted_address;
	populateAddressForm(addressObj, form);

}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
function geolocate() {
	if (navigator.geolocation && !geolocation) {
		navigator.geolocation.getCurrentPosition(function (position) {
			geolocation = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			};
			var circle = new google.maps.Circle({
				center: geolocation,
				radius: position.coords.accuracy
			});
			$('.addressForm .autocomplete').each(function () {
				if ($(this).data('autocomplete')) {
					$(this).data('autocomplete').setBounds(circle.getBounds());
				}
			});

		});
	}
}

function populateAddressForm(addressObj, form) {

	form.data('address', addressObj);
	form.find('.city').val(addressObj.city);
	form.find('.zipcode').val(addressObj.zipcode);
	form.find('.streetAddress').val(addressObj.street_number + (addressObj.street_number ? ' ' : '') +
		addressObj.route);

	form.find('.country').val(HF_GLOBALS.countriesIndex[addressObj.country]);
	$.when(updateRegions(HF_GLOBALS.countriesIndex[addressObj.country], form)).done(function (regions) {
		$.each(regions, function (index, region) {
			if (region.name == addressObj.region) {
				form.find('.region').val(region.id);
			}
		});
	});
}

function getAddresString(form) {
	var address = '';
	address = form.find('.streetAddress').val();
	address += (form.find(".unit").val() ?
		((address ? ', ' : '') + ' ' + form.find(".unit").val()) : '');
	address += (address ? ', ' : '') + form.find('.city').val();
	address += (address ? ', ' : '') + form.find('.region  option:selected').text();
	address += (address ? ' ' : '') + form.find('.zipcode').val();
	address += (address ? ', ' : '') + form.find('.country  option:selected').text();

	return address;
}

function getAddressFields(form) {
	var dfd = new $.Deferred();
	var obj = {
		address_name: form.find(".name").val(),
		address_streetAddress: form.find(".streetAddress").val(),
		address_unit: form.find(".unit").val(),
		address_city: form.find(".city").val(),
		address_regionId: form.find(".region").val(),
		address_countryId: form.find(".country").val(),
		address_zipcode: form.find(".zipcode").val()
	};

	var service = new google.maps.places.PlacesService(form.find('.attr')[0]);
	var request = {
		query: getAddresString(form),
		fields: ['formatted_address'],
	};

	service.findPlaceFromQuery(request, function (results, status) {
		if (status === google.maps.places.PlacesServiceStatus.OK) {
			if (results.length) {
				obj.address_string = results[0].formatted_address;
			}
		}
		dfd.resolve(obj);
	});
	return dfd.promise();
}

function init() {
	$('.addressForm .country').change(function () {
		updateRegions($(this).val(), $(this).closest('.addressForm'));

	});
	initializeAutoComplete();
}

export let address = { 
	getAddressFields: getAddressFields,
	initializeAutoComplete: initializeAutoComplete,
	displayRegions: displayRegions,
	init: init
};
